import aboutList from "../helpers/aboutList";

function AboutPart(props) {
    return (
        <li className="about-item">
            <img src={`./img/icon/${props.img}.png`} alt="" />
            <h3>{props.text}</h3>
        </li>
    );
}

export default function Home() {
    return (
        <main>
            <div className="offer">
                <div className="container">
                    <div className="offer-construction">
                        <h1>YarGoGDPS</h1>
                        <p>Устал от скучных приватных серверов? Наш сервер выбирают как хорошие креаторы, так и крутые демонслееры, мы имеем частые ивенты и крутые фишки. Если ты заинтересован в этом, присоединяйся!</p>
                        <a href="https://gofruit.space/gdps/053m" className="dwnl-offer-btn">Скачать сервер</a>
                    </div>
                </div>
                <div className="hero_area">
                    <svg className="waves" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" viewBox="0 24 150 28" preserveAspectRatio="none" shapeRendering="auto">
                        <defs>
                            <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"/>
                        </defs>
                        <g className="parallax">
                            <use xlinkHref="#gentle-wave" x="48" y="0" fill="rgba(255,255,255,0.7)" />
                            <use xlinkHref="#gentle-wave" x="48" y="3" fill="rgba(255,255,255,0.5)" />
                            <use xlinkHref="#gentle-wave" x="48" y="5" fill="rgba(255,255,255,0.3)" />
                            <use xlinkHref="#gentle-wave" x="48" y="7" fill="#fff" />
                        </g>
                    </svg>
                </div>
            </div>
            <div className="about">
                <div className="container">
                    <h2 className="about-header">У нас вы легко сможете</h2>
                    <ul className="about-list">
                        {
                            aboutList.map((e, index) => {
                                return <AboutPart key={index} img={e.img} text={e.text} />
                            })
                        }
                    </ul>
                </div>
            </div>
            <div className="">
                <div className="container">
                    <div className="discord">
                        <img src="./img/icon/ds.png" alt="" />
                        <div className="ds-text">
                            <h3>Присоединяйтесь к нашему дискорду!</h3>
                            <p>Если мы вас заинтересовали и вы хотите стать частью нашего большого и дружного комьюнити, заходите к нам в <a href="https://discord.gg/8ETWhDsSKH" target="_blank">дискорд</a>.</p>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
}